import React from 'react';

/** The id of an Activity section's anchor: "activity-writing". */
export const sectionAnchor = (key) => `activity-${key}`;

/** The id of its heading, which takes focus when a link moves to it (lib/scrollToSection). */
export const sectionTitleId = (key) => `${sectionAnchor(key)}-title`;

/**
 * One Activity section: an anchor the sticky links jump to, its title and
 * one-line description, then its content. The title is focusable from
 * script only (tabIndex -1), so a jump can hand it focus.
 */
const ActivitySection = ({ id, title, description, children }) => (
  <section id={sectionAnchor(id)} className="td-act-section" aria-labelledby={sectionTitleId(id)}>
    <h3 id={sectionTitleId(id)} className="td-act-section__title" tabIndex={-1}>{title}</h3>
    {description ? <p className="td-act-section__sub">{description}</p> : null}
    {children}
  </section>
);

export default ActivitySection;
